
const Services = () => {
  const services = [
    {
      icon: 'ri-footprint-line',
      title: 'Senderismo Ecológico',
      description: 'Explora los senderos más hermosos del páramo boyacense con guías expertos que te mostrarán la flora y fauna única de la región.',
      image: 'https://public.readdy.ai/ai/img_res/d146cab85faca70d2920081c4868343a.jpg'
    },
    {
      icon: 'ri-camera-line',
      title: 'Avistamiento de Aves',
      description: 'Descubre la increíble diversidad de aves del páramo, incluyendo colibríes, águilas y especies endémicas de los Andes colombianos.',
      image: 'https://readdy.ai/api/search-image?query=Birdwatching%20activity%20in%20Colombian%20paramo%2C%20tourists%20with%20binoculars%20observing%20colorful%20hummingbirds%20and%20native%20birds%2C%20misty%20mountain%20landscape%2C%20professional%20nature%20guide%20pointing%20at%20birds%2C%20early%20morning%20golden%20light&width=600&height=400&seq=aves&orientation=landscape'
    },
    {
      icon: 'ri-tent-line',
      title: 'Camping Aventura',
      description: 'Vive la experiencia única de acampar bajo las estrellas del páramo, con todas las comodidades y seguridad necesarias.',
      image: 'https://readdy.ai/api/search-image?query=Camping%20site%20in%20Colombian%20paramo%20at%20sunset%2C%20colorful%20tents%20set%20up%20in%20natural%20clearing%2C%20campfire%20with%20people%20around%20it%2C%20starry%20sky%20beginning%20to%20appear%2C%20mountain%20silhouettes%2C%20cozy%20outdoor%20adventure%20atmosphere&width=600&height=400&seq=camping&orientation=landscape'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Tours Fotográficos',
      description: 'Captura la belleza del páramo con tours especializados en fotografía de naturaleza y paisajes espectaculares.',
      image: 'https://readdy.ai/api/search-image?query=Photography%20tour%20in%20Colombian%20paramo%2C%20photographer%20capturing%20frailejones%20plants%20and%20mountain%20landscapes%2C%20professional%20camera%20equipment%2C%20golden%20hour%20lighting%2C%20misty%20atmosphere%2C%20nature%20photography%20workshop%20setting&width=600&height=400&seq=fotografia&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre la magia del páramo boyacense con nuestras experiencias de ecoturismo diseñadas para conectarte con la naturaleza de manera sostenible y responsable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute top-4 left-4 w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-white text-xl`}></i>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-green-800 mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a href="#contacto" className="bg-green-800 hover:bg-green-900 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer inline-block">
            <i className="ri-calendar-line mr-2"></i>
            Reserva Tu Aventura
          </a>
        </div>

      </div>
    </section>
  );
};

export default Services;
